var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online flex flex-right flex-middle",style:({
    background: ("white url(" + _vm.bg + ") no-repeat"),
    backgroundSize: 'auto 100%',
    backgroundPosition: '10% center',
  })},[_c('div',{staticClass:"online-inner"},[_c('div',{staticClass:"flex flex-row"},_vm._l((_vm.numString),function(item,index){return _c('div',{key:index,staticClass:"online-num"},[_vm._v(" "+_vm._s(item)+" ")])}),0),_c('div',{staticClass:"online-title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }